/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Faq_Q5_AnswerInputs */

const en_home_faq_q5_answer = /** @type {(inputs: Home_Faq_Q5_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emergency contact information is available through your portal and policy documents. Support is available 24/7.`)
};

const fr_home_faq_q5_answer = /** @type {(inputs: Home_Faq_Q5_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les coordonnées d'urgence sont disponibles via votre portail et vos documents de police. Le soutien est disponible 24/7.`)
};

/**
* | output |
* | --- |
* | "Emergency contact information is available through your portal and policy documents. Support is available 24/7." |
*
* @param {Home_Faq_Q5_AnswerInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_faq_q5_answer = /** @type {((inputs?: Home_Faq_Q5_AnswerInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Faq_Q5_AnswerInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_faq_q5_answer(inputs)
	return fr_home_faq_q5_answer(inputs)
});